module.exports = __webpack_public_path__ + "media/images/emblems/Sevaz-coat_of_arms-fb9d1382e90d9ad120842c0fbadc0c6b.svg";